module.exports = __webpack_public_path__ + "img/music-player.aff9e040.svg";